import { KeyCodes } from '@/consts/keyCodes';

export const blurOnKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
  if (event.key === KeyCodes.Enter) {
    event.currentTarget.blur();
  }
};

export const getDefaultRoleCode = (name: string, level: number) => {
  const matches = name.match(/\b(\w)/g);
  const acronym = matches ? matches.join('') : name.charAt(0);

  return acronym.toUpperCase() + level;
};
